'use client';

import type { ComponentProps, FC } from 'react';
import Link from 'next/link';
import { useIntentPrefetch } from '../../../hooks/useIntentPrefetch';

type WikiLinkProps = Omit<ComponentProps<typeof Link>, 'href' | 'prefetch'> & { href: string };

export const WikiLink: FC<WikiLinkProps> = ({ href, onMouseEnter, onFocus, onTouchStart, ...rest }) => {
  const intent = useIntentPrefetch()(href);
  return (
    <Link
      {...rest}
      href={href}
      prefetch={intent.prefetch}
      onMouseEnter={(e) => {
        intent.onMouseEnter();
        onMouseEnter?.(e);
      }}
      onFocus={(e) => {
        intent.onFocus();
        onFocus?.(e);
      }}
      onTouchStart={(e) => {
        intent.onTouchStart();
        onTouchStart?.(e);
      }}
    />
  );
};
